import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, Typography, Chip, Stack, Menu, MenuItem, Tooltip, Link } from '@mui/material';
import { Avatar, Button, Drawer, Modal, Spacer, TooltipWrapper } from 'src/components/shared';
import { isEmpty, isNull } from 'lodash';
import IntegrationStatus from './IntegrationStatus';
import { ProfileWrapper, Left, Right, JobLocation, SequenceInfo, ButtonLink } from './styles';
import {
  capitalizeName,
  getBounceTooltip,
  getSequenceStatus,
  getSequenceStatusColorCode,
} from '../../utils/contactUtils';
import { sequenceEnrollmentStatus } from '../../config';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import MailIcon from '@mui/icons-material/Mail';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { removeFromDraft } from 'src/modules/sequence/api/sequenceApi';
import { getActiveEnrolmentId, getEnrolments } from '../../saga/contactSagas';
import {
  enqueueSequencePersonalize,
  setReEnrolmentErrors,
  submitPersonalizeSequence,
} from 'src/modules/sequence/actions/enrolmentActions';
import toast from 'src/utils/toast';
import {
  addContactToSequence,
  fetchContactNotes,
  putContactDetails,
  putEnrollment,
  setSequenceEnroll,
  toggleContactForm,
} from '../../actions/contactActions';
import SequenceStages from 'src/modules/tasks/components/Tasks/SequenceStages';
import { bounceWarningMessage } from 'src/modules/tasks/config';
import ContactDetailsForm from '../ContactDetails/ContactDetailsForm';
import { AddToSequenceForm } from '../ContactActions';
import { connect } from 'react-redux';
import Icon from 'src/components/lms/Icon';
import { useTheme } from '@mui/styles';
import images from 'src/config/images';

function Profile({
  contact,
  showEdit,
  showAddress,
  type,
  onEnrol,
  putEnrollment,
  showEmail,
  email,
  toggleContactActionDrawer = () => null,
  ...props
}) {
  const {
    IN_PROGRESS,
    COMPLETED,
    HOLD,
    FAILED,
    BOUNCED,
    ERROR,
    INTERESTED,
    NOT_INTERESTED,
    NEVER_SEQUENCED,
    DRAFT,
    NEVER,
    PAUSED,
    REPLIED,
    HARD,
  } = sequenceEnrollmentStatus;
  if (isNull(contact) || isEmpty(contact) || !contact) return null;
  const theme = useTheme();
  const dispatch = useDispatch();
  const enrolments = useSelector(getEnrolments);
  const activeEnrollmentId =
    type === 'enrollment'
      ? useSelector(getActiveEnrolmentId)
      : useSelector((state) => state.contacts.sequenceEnrollment)?.[0]?.id;
  const sequenceEnrollment =
    type === 'enrollment'
      ? enrolments?.[activeEnrollmentId]
      : useSelector((state) => state.contacts.sequenceEnrollment)?.[0];
  const isBounceFormOpen = useSelector(state => state.contacts.isBounceFormOpen)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showAddToSequence, setShowAddToSequence] = useState(false);
  const [modalType, setModalType] = React.useState('');
  const open = Boolean(anchorEl);
  const [showActions, setShowActions] = useState(false);
  const name = capitalizeName(`${contact?.fname} ${contact?.lname}`);
  const isBounceWorkflowEnabled = useSelector(state => state.app.tenant)?.tenant_settings?.[0]?.isBounceWorkflowEnabled || false;
  const bounceEmailData = contact?.emails?.find(email => email?.email === sequenceEnrollment?.selectedEmailId) || {}

  const handleClick = (event) => {
    setModalType('menu');
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setModalType('');
    setAnchorEl(null);
  };

  useEffect(() => {
    setShowEmailModal(isBounceFormOpen)
  }, [isBounceFormOpen])

  const seqStatus = sequenceEnrollment
    ? sequenceEnrollment?.status
    : sequenceEnrollmentStatus.NEVER;
  const bounceType = sequenceEnrollment?.bounceType || "";
  const bounceWorkFlowStatus = sequenceEnrollment?.bounceWorkFlowStatus || ""
  const isHard = (bounceType === HARD);
  const isBounceStarted = (bounceWorkFlowStatus === "started")

  const jobTitle = contact?.jobTitle || undefined;
  const employer = contact?.employer || undefined;
  const activeSequence = sequenceEnrollment || {};

  const location = contact?.address && contact?.address.length > 0 ? contact?.address[0] : {};
  const jobLocation = `${location?.town || ''} ${location?.country ? ', ' + location?.country : ''
    }`;
  // const lastConnectedDate = moment(contact.updatedAt).format('ll') || '';
  const crmActiveField = ['bullhorn', 'vincere', 'jobadder', 'hubspot', 'salesforce']?.find(
    (crmField) => contact?.[crmField + 'Id'],
  );

  const crmActiveFieldType = crmActiveField
    ? contact?.[crmActiveField + 'Type'] === 'ClientContact'
      ? 'Contact'
      : contact?.[crmActiveField + 'Type']
    : null;

  const options = [
    ...([COMPLETED, INTERESTED, NOT_INTERESTED, NEVER, NEVER_SEQUENCED]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={(event) => {
            setShowAddToSequence(true);
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            Add to sequence
          </Stack>
        </MenuItem>,
      ]
      : []),

    ...([PAUSED, HOLD]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={() => {
            putEnrollment(activeSequence?.id, {
              status: IN_PROGRESS,
            });
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            <RestartAltRoundedIcon /> Resume
          </Stack>
        </MenuItem>,
      ]
      : []),
    ...([BOUNCED]?.includes(seqStatus) && !isBounceStarted && isHard
      ? [
        <MenuItem
          onClick={() => {
            setShowEmailModal(true);
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={2}>
            <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.hardBounced} />
            <Typography variant="h5">Update selected email address</Typography>
          </Stack>
        </MenuItem>,
      ]
      : []),
    ...([BOUNCED, IN_PROGRESS, REPLIED]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={() => {
            putEnrollment(activeSequence?.id, {
              status: INTERESTED,
            });
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={2}>
            <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.interested} />
            <Typography variant="h5">End sequence - Interested</Typography>
          </Stack>
        </MenuItem>,
      ]
      : []),

    ...([BOUNCED, IN_PROGRESS, REPLIED]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={() => {
            putEnrollment(activeSequence?.id, {
              status: NOT_INTERESTED,
            });
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={2}>
            <img width={'20px'} height={'20px'} src={images.sequence.statusIcon.notInterested} />
            <Typography variant="h5">End sequence - Not Interested</Typography>
          </Stack>
        </MenuItem>,
      ]
      : []),
    ...([ERROR, HOLD]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={() => {
            putEnrollment(activeSequence?.id, {
              status: COMPLETED,
            });
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            <DoneRoundedIcon /> Completed
          </Stack>
        </MenuItem>,
      ]
      : []),

    ...([IN_PROGRESS]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={() => {
            putEnrollment(activeSequence?.id, {
              status: HOLD,
            });
            handleClose();
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            <PauseRoundedIcon /> Pause
          </Stack>
        </MenuItem>,
      ]
      : []),
    ...([DRAFT]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={async () => {
            handleClose();
            const res = await removeFromDraft(activeEnrollmentId);
            if (res?.enrollment?.[0]?.id) {
              toast.success(
                'Contact successfully removed from the draft',
                type === 'enrollment' ? 'tl' : 'tr',
              );
              if (type === 'enrollment') {
                let nextIndex = 0;
                const filteredEnrollments = Object.keys(enrolments).reduce((acc, val, index) => {
                  if (enrolments?.[val]?.id !== activeEnrollmentId) acc[val] = enrolments[val];
                  else nextIndex = index;
                  return acc;
                }, {});
                dispatch(enqueueSequencePersonalize(filteredEnrollments, null, nextIndex));
              } else {
                dispatch(setSequenceEnroll([{ ...res.enrollment?.[0], status: 'never' }]));
              }
            }
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            Remove draft
          </Stack>
        </MenuItem>,
      ]
      : []),

    ...([DRAFT]?.includes(seqStatus)
      ? [
        <MenuItem
          onClick={async () => {
            handleClose();
            if (type === 'enrollment') onEnrol();
            else {
              const updatedEnrolment = await new Promise((resolve, reject) => {
                dispatch(submitPersonalizeSequence({}, true, resolve, reject));
              });
              dispatch(setSequenceEnroll(updatedEnrolment.enrolments));
            }
          }}
        >
          <Stack direction={'row'} alignItems={'center'}>
            Enrol prospect
          </Stack>
        </MenuItem>,
      ]
      : []),
  ];

  const onEmailModalClose = () => {
    setShowEmailModal(false);
    dispatch(toggleContactForm(false))
  };

  const editContactDetails = (data) => {
    return new Promise((resolve, reject) => {
      dispatch(putContactDetails(contact.id, "email", bounceEmailData.id, data, resolve, reject));
    });
  };

  const contactResponse = (emailData, type) => new Promise((resolve, reject) => dispatch(
    setReEnrolmentErrors(activeSequence.id, {
      reenroll: type,
      email: emailData.email
    }, resolve,
      reject),
  ))

  const onNextBounceError = async (emailData, type) => {
    try {
      switch (type) {
        case "current":
          let response = await contactResponse(emailData, type);
          props.fetchContact(response?.enrollment?.contact?.id || contact?.id)
          break;
        case "mark_done":
          putEnrollment(activeSequence.id, {
            status: `${activeSequence.status && NOT_INTERESTED}`,
          })
          let emailPayload = {
            email: emailData?.email || "",
            type: emailData?.type || "work",
            isPrimary: emailData?.isPrimary || false
          }
          await editContactDetails(emailPayload)
          break;
        default:
          break;
      }
    } catch (error) {
      console.log("errrorrr", error)
    }
  };

  const onSeqStatusClick = (event) => {
    if (!sequenceEnrollment?.tasks?.length) return null;
    setModalType('hover');
    setAnchorEl(event.currentTarget);
  };

  const isUnsubscribed = contact.status === 'unsubscribed';

  const toolTipContent = (bounceType = "", bounceWorkFlowStatus = "") => {
    return (
      <Box display="flex" gap="8px">
        <Icon name={isBounceWorkflowEnabled ? "bounceTooltip" : "errorCircle"} size={35} />
        <Box>
          <Typography variant="h5" sx={{ whiteSpace: 'pre-line' }}>
            {getBounceTooltip(bounceType, bounceWorkFlowStatus, isBounceWorkflowEnabled)}{" "}
            {isBounceWorkflowEnabled && (
              <Link target="_blank"
                rel="noopener noreferrer"
                underline="always"
                variant='h5'
                href={process.env[`REACT_APP_LEARN_MORE_${bounceType.toUpperCase()}_BOUNCE`]}
                sx={{ color: theme.palette.text.yellow }}
              >
                Learn More
              </Link>
            )}
          </Typography>
          {!isBounceWorkflowEnabled && (
            <ButtonLink onClick={() => setShowEmailModal(true)}>
              Update selected email address
            </ButtonLink>
          )}
        </Box>
      </Box>
    )
  }

  return (
    <ProfileWrapper
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <Stack direction={'row'} gap={'16px'}>
        <Left>
          <Avatar src={contact.imageUrl} name={name} size={50} />
          {type === 'enrollment' && (
            <Box
              sx={{ width: '100%', justifyContent: 'center', marginTop: '-14px', display: 'flex' }}
            >
              <IntegrationStatus contact={contact} />
            </Box>
          )}
        </Left>

        <Right>
          <Box display="flex" alignItems="center">
            <Typography variant="subtitle1" sx={{ fontSize: 18, fontWeight: 400 }}>
              <Stack direction="row" alignItems="center" gap={1}>
                {name}
                {showEmail && email !== '' && (
                  <Typography color="textSecondary" variant="body2">
                    {`< ${email} >`}
                  </Typography>
                )}
                {type === 'enrollment' && !!crmActiveFieldType && (
                  <Chip
                    sx={{
                      width: 'fit-content',
                      backgroundColor: '#4caf50',
                      color: 'white',
                      fontWeight: 400,
                      fontSize: 12,
                      height: 24,
                      marginLeft: '4px',
                      letterSpacing: '0.8px',
                    }}
                    label={crmActiveFieldType}
                  />
                )}
                {contact.icp && (
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={0.5}
                    p={0.5}
                    borderRadius="999px"
                    style={{
                      background:
                        'linear-gradient(90deg, rgba(244,148,246,1) 0%, rgba(168,127,254,1) 100%)',
                    }}
                  >
                    <Icon name="icp" />
                    <Typography
                      variant="subtitle2"
                      fontSize={10}
                      lineHeight={0}
                      color={theme.palette.text.black1}
                    >
                      ICP
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Typography>

            <Spacer basis={1} />

            {!isUnsubscribed && showEdit && showActions && type !== 'enrollment' && (
              <Box display="flex" pl={0.8}>
                <ButtonBase
                  onClick={() => {
                    props.toggleAddContactForm(contact);
                  }}
                >
                  <EditIcon className="edit-icon" />
                </ButtonBase>
              </Box>
            )}
          </Box>

          <Box>
            <span style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '15px' }}>
              {jobTitle ? jobTitle : null}
              <span style={{ color: 'rgb(128, 171, 205)' }}>
                {jobTitle && employer ? ` at ` : ' '}
              </span>

              {employer}
            </span>
            {showAddress && <JobLocation>{jobLocation || ''}</JobLocation>}

            {/* {type !== 'enrollment' && lastConnectedDate ? (
              <SequenceInfo variant="caption">Last Contacted {lastConnectedDate}</SequenceInfo>
            ) : null} */}
          </Box>

          <Spacer y={2} />

          <Stack direction="row" spacing={1}>
            {type !== 'enrollment' && <IntegrationStatus contact={contact} />}
            <Tooltip
              title={isUnsubscribed ? 'Cannot perform this action on an unsubscribed user.' : ''}
            >
              <Stack direction="row" alignItems="center">
                <TooltipWrapper
                  title={toolTipContent(bounceType, bounceWorkFlowStatus)}
                  bgColor={isBounceWorkflowEnabled ? theme.palette.background.dark : theme.palette.background.lightRed}
                  textColor={isBounceWorkflowEnabled ? theme.palette.text.white : theme.palette.text.red}
                  tooltip={seqStatus === sequenceEnrollmentStatus.BOUNCED}
                >
                  <Chip
                    label={getSequenceStatus(seqStatus, bounceType)}
                    disabled={isUnsubscribed}
                    onClick={onSeqStatusClick}
                    sx={{
                      backgroundColor: getSequenceStatusColorCode(seqStatus, bounceType).background,
                      color: getSequenceStatusColorCode(seqStatus, bounceType).color,
                      fontSize: '12px',
                      cursor: 'pointer',
                      height: '28px',
                    }}
                  />
                </TooltipWrapper>
                {!isUnsubscribed && options?.length !== 0 && (
                  <Button
                    sx={{ padding: 0, minWidth: 'auto' }}
                    onClick={handleClick}
                    variant="text"
                  >
                    <ArrowDropDownIcon />
                  </Button>
                )}
              </Stack>
            </Tooltip>
            <Menu
              open={open && modalType === 'menu'}
              anchorEl={anchorEl}
              iconButton={false}
              onClose={handleClose}
              buttonStyles={{ padding: 0, textTransform: 'none', fontWeight: 'normal' }}
              disableScrollLock
            >
              {options?.map((item) => item)}
            </Menu>
            <Menu
              open={open && modalType === 'hover'}
              anchorEl={anchorEl}
              iconButton={false}
              onClose={handleClose}
              buttonStyles={{ padding: 0, textTransform: 'none', fontWeight: 'normal' }}
            >
              <SequenceStages
                seqStag={sequenceEnrollment}
                enrolment={sequenceEnrollment}
                enrolmentLoading={false}
                type="profile"
                onClose={handleClose}
                toolTipContent={toolTipContent}
                isBounceWorkflowEnabled={isBounceWorkflowEnabled}
              />
            </Menu>
          </Stack>
        </Right>
      </Stack>
      <Drawer
        open={showAddToSequence}
        title={<Typography fontSize={20}>Add to sequence</Typography>}
        onClose={() => setShowAddToSequence(false)}
      >
        <AddToSequenceForm
          contact={contact}
          addContactToSequence={props.addContactToSequence}
          fetchContactNotes={props.fetchContactNotes}
          onClose={() => setShowAddToSequence(false)}
        />
      </Drawer>
      <Modal
        open={showEmailModal}
        onClose={onEmailModalClose}
        title={bounceWarningMessage}
        size="xs"
      >
        <ContactDetailsForm
          formType={'email'}
          formData={{ ...bounceEmailData, isBounce: true }}
          onSubmit={onNextBounceError}
          onClose={onEmailModalClose}
          submitButtonText={'Next'}
        />
      </Modal>
    </ProfileWrapper>
  );
}


Profile.defaultProps = {
  showEdit: true,
  showBullhornButton: true,
  showAddress: true,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  fetchContactNotes: (contactId, filter, paging) =>
    dispatch(fetchContactNotes(contactId, filter, paging)),

  addContactToSequence: (sequenceId, contactId) => {
    return new Promise((resolve, reject) => {
      dispatch(addContactToSequence(sequenceId, contactId, resolve, reject));
    });
  },
  putEnrollment: (id, enrollment) => dispatch(putEnrollment(id, enrollment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
